import { useParams, Redirect } from "react-router-dom";
import Package1 from "./Package1.js";
import Package2 from "./Package2.js";
import Package3 from "./Package3.js";
import Package4 from "./Package4.js";

const Preconfigured = () => {
    const params = useParams();
    const id = Number(params.id);
    const backToLabel = "Ofuro Hot Tub";

    if (id === 1) return <Package1 backToLabel={backToLabel} />;

    if (id === 2) return <Package2 backToLabel={backToLabel} />;

    if (id === 3) return <Package3 backToLabel={backToLabel} />;

    if (id === 4) return <Package4 backToLabel={backToLabel} />;

    return <Redirect to="/" />;
};

export default Preconfigured;
